<template lang="pug">
  shListData(title="Sizes History" resolver="sizesHistory" keyData="_id" component="shSize" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'SizesHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/size/SizesHistory.vue